import Provider from "../Provider";
import LocalizationContextType from "./LocalizationContextType";

export default interface LocalizationProvider extends Provider<LocalizationContextType> {
}

export const LocalizationProviderName = "LocalizationProvider";
